export function addBootgridData(serializedForm: FormData, wizardForm: JQuery<HTMLFormElement>): void {
    addParameterBootgridData(wizardForm, serializedForm);
    addRecordBootgridData(wizardForm, serializedForm);
}

function addRecordBootgridData(wizardForm: JQuery<HTMLFormElement>, serializedForm: FormData) {
    const recordBootgrids = getRecordBootgrids(wizardForm);
    if (recordBootgrids.length > 0) {
        recordBootgrids.each(function () {
            const bootgrid = $(this);
            const keyColumnName = bootgrid.data("luscinia-keycolumnname") as string;
            const obj = (bootgrid as any).bootgrid("getObject");
            const selectedRowIds: string[] = (bootgrid as any).bootgrid("getSelectedRowIds");
            serializedForm.append(`${(bootgrid.data("luscinia-field-name") as string).toLowerCase()}-selectedrows`, selectedRowIds.join(","));
            serializedForm.append(`${(bootgrid.data("luscinia-field-name") as string).toLowerCase()}-displayedrows`, obj.rows.map(x => x[keyColumnName]).join(','));
        });
    }
}

function addParameterBootgridData(wizardForm: JQuery<HTMLFormElement>, serializedForm: FormData) {
    const parameterBootgrids = getParameterBootgrids(wizardForm);
    if (parameterBootgrids.length > 0) {
        parameterBootgrids.each(function () {
            const bootgrid = $(this);
            const keyColumnName = bootgrid.data("luscinia-keycolumnname") as string;
            const obj = (bootgrid as any).bootgrid("getObject");
            const selectedRowIds: string[] = (bootgrid as any).bootgrid("getSelectedRowIds");
            const selectedRows = obj.rows.filter(row => selectedRowIds.includes(row[keyColumnName]));
            serializedForm.append(`${(bootgrid.data("luscinia-field-name") as string).toLowerCase()}-selectedrows`, JSON.stringify(selectedRows));
            serializedForm.append(`${(bootgrid.data("luscinia-field-name") as string).toLowerCase()}-displayedrows`, JSON.stringify(obj.rows));
        });
    }
    
}
function getParameterBootgrids(wizardForm: JQuery<HTMLFormElement>) {
    return wizardForm.find('table[data-parameterbootgrid="true"]');
}
function getRecordBootgrids(wizardForm: JQuery<HTMLFormElement>) {
    return wizardForm.find('table:not([data-parameterbootgrid]), table[data-parameterbootgrid="false"]');
}
